module.exports = __webpack_public_path__ + "assets/be397e186df61e831337398bf954d6cf.mp3";